import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ListStudentiDTO,
  StudenteDTO,
  ListSelectDTO,
  ListLaboratorioPresenze,
  ListGruppoStudioPresenze,
  ListRisultatoProvaFinaleDTO,
} from 'src/app/model/newModel';
import { ConstantsCLA } from '../../../shared/constants-cla';
import {
  AddUpdateStudenteCommand,
  GetStudenteCommand,
  AddUpdateSessioneOlaStudenteCommand,
} from 'src/app/model/command-model';
import {
  SelectCommand,
  SearchStudentiCommand,
} from '../../../model/command-model';

@Injectable({
  providedIn: 'root',
})
export class AStudenteService {
  constructor(private http: HttpClient) {}

  update(updateStudente: AddUpdateStudenteCommand) {
    return this.http.post<AddUpdateStudenteCommand>(
      ConstantsCLA.MODIFICA_STUDENTE_OLA_URL,
      updateStudente
    );
  }

  resetPwd(updateStudente: AddUpdateStudenteCommand) {
    return this.http.post<AddUpdateStudenteCommand>(
      ConstantsCLA.MODIFICA_PWD_STUDENTE_OLA_URL,
      updateStudente
    );
  }

  save(save: AddUpdateStudenteCommand) {
    return this.http.post<AddUpdateStudenteCommand>(
      ConstantsCLA.CREA_STUDENTE_OLA_URL,
      save
    );
  }

  selectGruppiStudio(idSessioneOla: number) {
    const command = new SelectCommand();
    command.idSessioneOla = idSessioneOla;
    return this.http.post<ListSelectDTO>(
      ConstantsCLA.GRUPPI_STUDIO_COMBO_URL,
      command
    );
  }

  getStudente(idStudente: number, idSessioneOla: number) {
    const studenteCommand = new GetStudenteCommand();
    studenteCommand.id = idStudente;
    studenteCommand.withInfoCorsoLaurea = true;
    studenteCommand.withInfoGruppoStudio = true;
    studenteCommand.idSessioneOla = idSessioneOla;

    return this.http.post<StudenteDTO>(
      ConstantsCLA.GET_STUDENTE_URL,
      studenteCommand
    );
  }

  getPresenzaAulaStudente(idStudente: number) {
    const studenteCommand = new GetStudenteCommand();
    studenteCommand.id = idStudente;
    return this.http.post<ListGruppoStudioPresenze>(
      ConstantsCLA.GET_GRUPPO_STUDIO_PRESENZE_URL,
      studenteCommand
    );
  }

  getPresenzeLaboratorio(idStudente: number) {
    const studenteCommand = new GetStudenteCommand();
    studenteCommand.id = idStudente;
    return this.http.post<ListLaboratorioPresenze>(
      ConstantsCLA.GET_LABORATORIO_PRESENZE_URL,
      studenteCommand
    );
  }


  storicoProvaFinale(idStudente : number) {
    const studenteCommand = new GetStudenteCommand();
    studenteCommand.id = idStudente;
    return this.http.post<ListRisultatoProvaFinaleDTO>(
      ConstantsCLA.STUDENTI_STORICO_PROVA_FINALE_SEARCH_URL,
      studenteCommand
    );
  }


  search(
    idSessioneOla: number,
    idCorsoLaurea: number,
    matricola: number,
    cognome: string
  ) {
    const command = new SearchStudentiCommand();
    command.idSessioneOla = idSessioneOla;
    command.idCorsoLaurea = idCorsoLaurea;
    command.matricola = matricola;
    command.cognome = cognome;
    command.skip = 0;
    command.take = 10;
    command.withInfoGruppoStudio = true;

    return this.http.post<ListStudentiDTO>(
      ConstantsCLA.STUDENTI_SEARCH_URL,
      command
    );
  }

  previousPage(
    idSessioneOla: number,
    idCorsoLaurea: number,
    matricola: number,
    cognome: string,
    skip: number,
    take: number
  ) {
    const skipNew = skip - 1 < 0 ? 0 : skip - 1;
    const command = new SearchStudentiCommand();
    command.idSessioneOla = idSessioneOla;
    command.idCorsoLaurea = idCorsoLaurea;
    command.matricola = matricola;
    command.cognome = cognome;
    command.skip = skipNew;
    command.take = take;
    command.withInfoGruppoStudio = true;
    return this.http.post<ListStudentiDTO>(
      ConstantsCLA.STUDENTI_SEARCH_URL,
      command
    );
  }

  nextPage(
    idSessioneOla: number,
    idCorsoLaurea: number,
    matricola: number,
    cognome: string,
    skip: number,
    take: number,
    count: number
  ) {
    const skipNew = skip + 1;
    const command = new SearchStudentiCommand();
    command.idSessioneOla = idSessioneOla;
    command.idCorsoLaurea = idCorsoLaurea;
    command.matricola = matricola;
    command.cognome = cognome;
    command.skip = skipNew;
    command.take = take;
    command.withInfoGruppoStudio = true;
    return this.http.post<ListStudentiDTO>(
      ConstantsCLA.STUDENTI_SEARCH_URL,
      command
    );
  }

  goToPage(
    idSessioneOla: number,
    idCorsoLaurea: number,
    matricola: number,
    cognome: string,
    idVaiA: string,
    take: number
  ) {
    const command = new SearchStudentiCommand();
    command.idSessioneOla = idSessioneOla;
    command.idCorsoLaurea = idCorsoLaurea;
    command.matricola = matricola;
    command.cognome = cognome;
    command.skip = Number(idVaiA);
    command.take = take;
    command.withInfoGruppoStudio = true;
    return this.http.post<ListStudentiDTO>(
      ConstantsCLA.STUDENTI_SEARCH_URL,
      command
    );
  }

  aggiungiOraLaboratorio(command: AddUpdateSessioneOlaStudenteCommand) {
    return this.http.post<Boolean>(
      ConstantsCLA.STUDENTI_ADD_ORA_LABORATORIO_URL,
      command
    );
  }
}
